export default __webpack_public_path__ + "static/media/svg-1.4b187b36.svg";